import React from 'react';

import { noop } from 'lodash-es';

import * as S from './styles';
import { useTab } from 'global/TabContext';
import theme from 'styles/theme';

import type { TabsProps } from 'antd';

interface TabsCustomProps {
  onChange?: (activeTab: string) => void;
  labels: any[];
  content: React.ReactNode[];
  title?: string;
  subtitle?: string;
  activeTab?: string;
  fitContent?: boolean;
  labelFontSize?: string;
}

const TabsCustom: React.FC<TabsCustomProps> = ({
  labels,
  title,
  subtitle,
  content,
  onChange = noop,
  activeTab: externalActiveTab,
  fitContent = false,
  labelFontSize = theme.FONT_SIZE.SM,
}) => {
  const { activeTabContext, setActiveTabContext } = useTab();

  const handleChange = (activeKey: string) => {
    onChange(activeKey);
    setActiveTabContext(activeKey);
  };

  const items: TabsProps['items'] = labels.map((label, index) => {
    return {
      key: label?.key,
      label: (
        <S.WrapperText fitContent={fitContent}>
          <S.TabText
            withTitle={!!title}
            disabled={label?.disabled}
            fitContent={fitContent}
            fontSize={labelFontSize}
          >
            {title && (
              <>
                {title}
                <br />
              </>
            )}
            {label?.label}
            <br />
            {label?.sub_label}
          </S.TabText>
        </S.WrapperText>
      ),
      children:
        (externalActiveTab || activeTabContext) === label?.key ? (
          <S.ContentTab>{content[index]}</S.ContentTab>
        ) : null,
      disabled: label?.disabled,
    };
  });

  return (
    <S.StyledTabs
      activeKey={externalActiveTab || activeTabContext}
      items={items}
      onChange={handleChange}
      style={{ width: '100%' }}
    />
  );
};

export default TabsCustom;
